// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"AdInquiryFormGroup_buttonContainer__1tG55","sending":"AdInquiryFormGroup_sending__20OuQ"};